import React, { useCallback, useEffect, useState } from "react";
import "./index.css";
import { useNavigate, useParams } from "react-router-dom";
import HeadingComponent from "../../components/HeadingComponent";
import {
  deleteMember,
  getPropertyMembers,
  removeMember,
} from "./APIs/firebaseMemberSettingApi";
import { Button, Col, Row, Space, message } from "antd";
import CustomTable from "../../components/CustomTable";
import DeleteModal from "../../components/DeleteModal";
import { EditOutlined } from "@ant-design/icons";
import { addMemberModel } from "./constants";
import MemberForm from "./MemberForm";
import { getRoles } from "../../firebase/queries";
import { useSelector } from "react-redux";

const Members = () => {
  const propertyId = useParams()?.propertyId;
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const properties = useSelector((state) => state.properties.properties);

  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ ...addMemberModel });
  const [roles, setRoles] = useState([]);

  const handleDeleteInvited = async (memberId) => {
    setLoading(true);
    await deleteMember(memberId, propertyId).finally(() => {
      setLoading(false);
    });
    const filtered = members?.filter((member) => member.id !== memberId);
    setMembers(filtered);
    message.success("Invite deleted");
  };

  const handleDeleteMember = async (memberId) => {
    setLoading(true);
    const property = properties.find((row) => row.id === propertyId);
    let admins = property.admins || [];
    admins = admins.filter((row) => row !== memberId);
    await removeMember(memberId, propertyId, admins).finally(() => {
      setLoading(false);
    });
    const filtered = members.filter((member) => member.id !== memberId);
    setMembers(filtered);
    message.success("Member deleted");
  };

  //Invited members data and column for table
  const columns = [
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (role) => <span>{role?.name}</span>,
    },
    {
      title: "Invited By",
      dataIndex: "invitedBy",
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <DeleteModal
            handleDelete={() => handleDeleteInvited(record?.id)}
            title="Are you sure you want to delete this member?"
          />
        </Space>
      ),
    },
  ];

  //Property members data and column for table
  const propertyMembersColumn = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (role) => <span>{role?.name}</span>,
    },
    {
      title: "Invited By",
      dataIndex: "invitedBy",
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <>
            <EditOutlined
              className="icons_style"
              onClick={() => {
                setModalData(record);
                displayModal();
              }}
            />
            <DeleteModal
              handleDelete={() => handleDeleteMember(record?.id)}
              title="Are you sure you want to delete this member?"
            />
          </>
        </Space>
      ),
    },
  ];

  const handleBackButtonClick = useCallback(() => {
    navigate(`/properties`);
  }, []);

  useEffect(() => {
    if (propertyId) {
      const fetchPropertyMembers = async () => {
        setLoading(true);
        const response = await getPropertyMembers(propertyId).finally(() => {
          setLoading(false);
        });

        setMembers(response);
      };
      fetchPropertyMembers();
    }
  }, [propertyId]);

  const displayModal = () => {
    setShowModal(true);
  };

  const setMemberCallback = useCallback((data) => {
    setMembers((prevState) => {
      if (prevState.find((row) => row.id === data.id)) {
        const index = prevState.findIndex((row) => row.id === data.id);
        prevState.splice(index, 1, data);
        return [...prevState];
      } else {
        return [...prevState, data];
      }
    });
  }, []);

  const hideModalCallback = useCallback(() => {
    setShowModal(false);
    setModalData();
  }, []);

  const setLoadingCallback = useCallback(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchRoles();
  }, [user]);

  const fetchRoles = async () => {
    const response = await getRoles().catch((e) => {
      console.log(e);
    });
    if (response) {
      setRoles(response);
    }
  };
  return (
    <>
      <div>
        <button className="backBtn" onClick={handleBackButtonClick}>
          <i className="fa-solid fa-arrow-left"></i>
          Back
        </button>
      </div>

      <div>
        <Row>
          <Col xs={24} sm={12}>
            <HeadingComponent text="Invited Members" />
          </Col>

          <Col
            xs={24}
            sm={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button onClick={displayModal}>Add Members</Button>
          </Col>
        </Row>

        <br />
        <CustomTable
          dataSource={members.filter((member) => member?.invited)}
          columns={columns}
          loading={loading}
        />
      </div>

      <br />

      <div>
        <HeadingComponent text="Members" />
        <br />
        <CustomTable
          dataSource={members}
          columns={propertyMembersColumn}
          loading={loading}
        />
      </div>
      {showModal && (
        <MemberForm
          showModal={showModal}
          hideModal={hideModalCallback}
          setLoading={setLoadingCallback}
          setMembers={setMemberCallback}
          modalData={modalData}
          selectedProperty={propertyId}
          members={members}
          roles={roles}
          user={user}
          properties={properties}
        />
      )}
    </>
  );
};

export default Members;
